export interface Chapter {
  id: string;
  comicId: string;
  title: string;
  number: number;
  updatedAt: string;
  views: number;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  description: string;
  status: string;
  rating: number;
  views: number;
  updatedAt: string;
  chapters: Chapter[];
  tags: string[];
}

export const categories = [
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { name: '喜剧', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { name: '动作', slug: 'action', icon: 'ri-sword-line' },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line' },
  { name: '日常', slug: 'slice-of-life', icon: 'ri-sun-line' },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line' },
  { name: '恐怖', slug: 'horror', icon: 'ri-ghost-line' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '她的私密花园',
    author: '金秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20illustration%20of%20a%20young%20woman%20in%20a%20flower%20garden%20with%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20clean%20simple%20background%20with%20cherry%20blossoms%2C%20manga%20style%20art%2C%20warm%20lighting%2C%20soft%20focus%2C%20Korean%20manhwa%20aesthetic&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '在繁忙的首尔都市中，两个看似毫无交集的人因为一个偶然的机会相遇了。一个是内向的花艺师，一个是冷漠的企业高管。他们的故事从一间小小的花店开始，在花香与误会中，两颗心慢慢靠近。这是一部温暖治愈的都市爱情故事，讲述了平凡生活中的不平凡邂逅。',
    status: '连载中',
    rating: 4.8,
    views: 1280000,
    updatedAt: '2026-08-04',
    tags: ['都市', '治愈', '职场', '甜宠'],
    chapters: [
      { id: 'ch-1-20', comicId: 'comic-1', title: '第20话 心动的瞬间', number: 20, updatedAt: '2026-08-04', views: 85000 },
      { id: 'ch-1-19', comicId: 'comic-1', title: '第19话 雨中的约定', number: 19, updatedAt: '2026-07-28', views: 92000 },
      { id: 'ch-1-18', comicId: 'comic-1', title: '第18话 意外的告白', number: 18, updatedAt: '2026-07-21', views: 98000 },
      { id: 'ch-1-17', comicId: 'comic-1', title: '第17话 深夜的电话', number: 17, updatedAt: '2026-07-14', views: 89000 },
      { id: 'ch-1-16', comicId: 'comic-1', title: '第16话 她的秘密', number: 16, updatedAt: '2026-07-07', views: 91000 },
    ],
  },
  {
    id: 'comic-2',
    title: '重生之商业帝国',
    author: '李正浩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20man%20in%20a%20luxurious%20office%20with%20city%20skyline%20through%20window%2C%20dramatic%20lighting%2C%20clean%20sharp%20art%20style%2C%20professional%20atmosphere%2C%20dark%20blue%20and%20gold%20accents%2C%20webtoon%20aesthetic&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '剧情',
    categorySlug: 'drama',
    description: '商场精英李俊昊在一场阴谋中失去一切，却意外重生回到十年前。带着前世的记忆和对未来的预知，他决定重新打造属于自己的商业帝国。但这一次，他不会再相信任何人。背叛、复仇、商战，一个关于重生与逆袭的精彩故事。',
    status: '连载中',
    rating: 4.9,
    views: 2350000,
    updatedAt: '2026-08-03',
    tags: ['重生', '商战', '复仇', '逆袭'],
    chapters: [
      { id: 'ch-2-35', comicId: 'comic-2', title: '第35话 棋局开始', number: 35, updatedAt: '2026-08-03', views: 125000 },
      { id: 'ch-2-34', comicId: 'comic-2', title: '第34话 幕后黑手', number: 34, updatedAt: '2026-07-27', views: 132000 },
      { id: 'ch-2-33', comicId: 'comic-2', title: '第33话 险中求胜', number: 33, updatedAt: '2026-07-20', views: 128000 },
    ],
  },
  {
    id: 'comic-3',
    title: '魔法学院优等生',
    author: '朴智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20illustration%20of%20a%20young%20student%20in%20a%20magical%20academy%20uniform%20with%20floating%20spells%2C%20mystical%20blue%20and%20purple%20ambient%20light%2C%20magic%20school%20setting%2C%20webtoon%20style%20art%2C%20detailed%20character%20design%2C%20clean%20simple%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '在隐藏于现代世界之下的魔法学院中，平凡少女林小雅意外发现自己拥有罕见的魔法天赋。从被嘲笑的后进生到学院最强的魔法师，她用实力证明了一切。友情、成长、冒险，以及隐藏在学院深处的古老秘密，等待着被揭开。',
    status: '连载中',
    rating: 4.7,
    views: 1890000,
    updatedAt: '2026-08-02',
    tags: ['魔法', '学院', '成长', '冒险'],
    chapters: [
      { id: 'ch-3-42', comicId: 'comic-3', title: '第42话 远古魔法', number: 42, updatedAt: '2026-08-02', views: 105000 },
      { id: 'ch-3-41', comicId: 'comic-3', title: '第41话 试炼之路', number: 41, updatedAt: '2026-07-26', views: 112000 },
      { id: 'ch-3-40', comicId: 'comic-3', title: '第40话 暗影来袭', number: 40, updatedAt: '2026-07-19', views: 118000 },
    ],
  },
  {
    id: 'comic-4',
    title: '剑道无双',
    author: '崔武镇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20illustration%20of%20a%20swordsman%20in%20dynamic%20pose%20with%20flowing%20martial%20arts%20robes%2C%20dramatic%20wind%20effect%2C%20intense%20battle%20atmosphere%2C%20dark%20background%20with%20moonlight%2C%20webtoon%20style%2C%20sharp%20linework%2C%20powerful%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '在剑道没落的现代，少年韩武英继承了家族失传的剑术秘籍。从一个普通高中生，到站在世界武术巅峰的剑道大师。他用手中的剑，守护重要的人和事。热血沸腾的格斗场面，精彩绝伦的武术对决，不容错过。',
    status: '连载中',
    rating: 4.6,
    views: 1560000,
    updatedAt: '2026-08-01',
    tags: ['武术', '校园', '热血', '格斗'],
    chapters: [
      { id: 'ch-4-28', comicId: 'comic-4', title: '第28话 最终对决', number: 28, updatedAt: '2026-08-01', views: 95000 },
      { id: 'ch-4-27', comicId: 'comic-4', title: '第27话 突破极限', number: 27, updatedAt: '2026-07-25', views: 101000 },
    ],
  },
  {
    id: 'comic-5',
    title: '甜蜜的谎言',
    author: '尹素熙',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20comedy%20illustration%20of%20a%20happy%20couple%20in%20a%20cozy%20cafe%20setting%20with%20warm%20lighting%2C%20cute%20expressions%2C%20pastel%20pink%20and%20cream%20colors%2C%20lighthearted%20romantic%20atmosphere%2C%20webtoon%20style%2C%20clean%20simple%20design&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '喜剧',
    categorySlug: 'comedy',
    description: '为了躲避家人的催婚，广告设计师韩智恩编造了一个完美的男友。然而当谎言即将被揭穿时，她的上司——冷酷又挑剔的创意总监竟然主动提出假扮她的男友。一场啼笑皆非的假恋爱就此展开，谎言的背后，会开出怎样的花朵？',
    status: '已完结',
    rating: 4.5,
    views: 2100000,
    updatedAt: '2026-07-15',
    tags: ['假恋爱', '办公室', '搞笑', '甜宠'],
    chapters: [
      { id: 'ch-5-50', comicId: 'comic-5', title: '第50话 真诚的告白（最终话）', number: 50, updatedAt: '2026-07-15', views: 200000 },
      { id: 'ch-5-49', comicId: 'comic-5', title: '第49话 最后的谎言', number: 49, updatedAt: '2026-07-08', views: 180000 },
    ],
  },
  {
    id: 'comic-6',
    title: '暗夜追踪者',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20mystery%20thriller%20illustration%20of%20a%20detective%20in%20a%20dark%20rainy%20alley%20with%20neon%20reflections%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20tense%20mood%2C%20webtoon%20style%20art%2C%20cinematic%20lighting%2C%20mysterious%20vibe&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    description: '首尔夜晚的街头，连环失踪案让整座城市陷入恐慌。刑警朴正宇在调查中发现，所有线索都指向一个神秘的组织。随着调查深入，他发现自己也被卷入了一场更大的阴谋之中。真相与谎言交织，谁才是真正的幕后黑手？',
    status: '连载中',
    rating: 4.8,
    views: 1780000,
    updatedAt: '2026-08-04',
    tags: ['悬疑', '刑侦', '犯罪', '推理'],
    chapters: [
      { id: 'ch-6-18', comicId: 'comic-6', title: '第18话 失踪的证人', number: 18, updatedAt: '2026-08-04', views: 88000 },
      { id: 'ch-6-17', comicId: 'comic-6', title: '第17话 地下交易', number: 17, updatedAt: '2026-07-28', views: 93000 },
    ],
  },
  {
    id: 'comic-7',
    title: '猫咪咖啡厅',
    author: '郑多彬',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20slice%20of%20life%20illustration%20of%20a%20girl%20with%20cats%20in%20a%20cozy%20cat%20cafe%2C%20warm%20sunlight%20through%20windows%2C%20soft%20comforting%20colors%2C%20relaxing%20atmosphere%2C%20webtoon%20aesthetic%2C%20gentle%20and%20healing%20vibe&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '日常',
    categorySlug: 'slice-of-life',
    description: '辞去高压工作的柳美英在首尔弘大开了一家小小的猫咪咖啡厅。每天与可爱的猫咪和形形色色的客人相处，她的生活变得简单而幸福。这是一部治愈系的日常漫画，讲述了人与猫之间温暖的羁绊，以及在平凡日常中发现的微小幸福。',
    status: '连载中',
    rating: 4.4,
    views: 890000,
    updatedAt: '2026-08-02',
    tags: ['治愈', '猫咪', '日常', '美食'],
    chapters: [
      { id: 'ch-7-12', comicId: 'comic-7', title: '第12话 新来的小橘猫', number: 12, updatedAt: '2026-08-02', views: 45000 },
      { id: 'ch-7-11', comicId: 'comic-7', title: '第11话 雨天的客人', number: 11, updatedAt: '2026-07-26', views: 48000 },
    ],
  },
  {
    id: 'comic-8',
    title: '鬼校异闻录',
    author: '安在旭',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20horror%20illustration%20of%20an%20abandoned%20school%20corridor%20at%20night%20with%20eerie%20atmosphere%2C%20cold%20blue%20lighting%2C%20mysterious%20shadow%2C%20dark%20corners%2C%20webtoon%20horror%20style%2C%20tense%20suspenseful%20mood%2C%20clean%20detailed%20art&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '恐怖',
    categorySlug: 'horror',
    description: '新建成的世宗高中流传着一个可怕的传说：每到月圆之夜，废弃的旧校舍中就会传出诡异的哭声。转学生姜秀雅不信鬼神，直到那个夜晚她亲眼目睹了无法解释的景象。校园恐怖故事，胆小者慎入。',
    status: '连载中',
    rating: 4.3,
    views: 1020000,
    updatedAt: '2026-08-03',
    tags: ['校园', '灵异', '惊悚', '超自然'],
    chapters: [
      { id: 'ch-8-15', comicId: 'comic-8', title: '第15话 镜中的她', number: 15, updatedAt: '2026-08-03', views: 72000 },
      { id: 'ch-8-14', comicId: 'comic-8', title: '第14话 三楼禁区', number: 14, updatedAt: '2026-07-27', views: 78000 },
    ],
  },
  {
    id: 'comic-9',
    title: '闪耀的我们',
    author: '刘智媛',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20romance%20illustration%20of%20two%20young%20people%20sitting%20on%20a%20rooftop%20watching%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20emotional%20and%20tender%20atmosphere%2C%20youth%20and%20first%20love%20theme%2C%20webtoon%20art%20style%2C%20heartfelt%20mood&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '从小就认识的两个青梅竹马，在高中时代慢慢意识到彼此的感情早已超越了友情。但高考、家庭、未来，种种现实的考验摆在面前。青春就是这样，既美好又残酷。一部关于初恋、成长与选择的青春恋歌。',
    status: '已完结',
    rating: 4.9,
    views: 3200000,
    updatedAt: '2026-06-20',
    tags: ['青春', '校园', '青梅竹马', '纯爱'],
    chapters: [
      { id: 'ch-9-65', comicId: 'comic-9', title: '第65话 我们的未来（最终话）', number: 65, updatedAt: '2026-06-20', views: 350000 },
      { id: 'ch-9-64', comicId: 'comic-9', title: '第64话 毕业那天', number: 64, updatedAt: '2026-06-13', views: 310000 },
    ],
  },
  {
    id: 'comic-10',
    title: '天命之刃',
    author: '张贤宇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20fantasy%20illustration%20of%20a%20warrior%20holding%20a%20glowing%20magical%20sword%20in%20ancient%20Korean%20setting%2C%20epic%20landscape%20background%2C%20dynamic%20pose%2C%20dramatic%20lighting%2C%20traditional%20Korean%20aesthetic%2C%20webtoon%20style&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '在古代朝鲜的奇幻世界中，一把传说中的神剑「天命之刃」重现人间。少年侠客李玄被命运选中，踏上了寻找神剑碎片、拯救苍生的冒险旅程。宏大的世界观，精彩的武打场面，带你进入一个充满东方奇幻色彩的武侠世界。',
    status: '连载中',
    rating: 4.7,
    views: 1450000,
    updatedAt: '2026-08-05',
    tags: ['武侠', '奇幻', '冒险', '古风'],
    chapters: [
      { id: 'ch-10-22', comicId: 'comic-10', title: '第22话 龙潭虎穴', number: 22, updatedAt: '2026-08-05', views: 68000 },
      { id: 'ch-10-21', comicId: 'comic-10', title: '第21话 剑灵觉醒', number: 21, updatedAt: '2026-07-29', views: 73000 },
    ],
  },
  {
    id: 'comic-11',
    title: '办公室罗曼史',
    author: '权恩彬',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20office%20romance%20illustration%20of%20a%20man%20and%20woman%20in%20business%20attire%20sharing%20a%20moment%20in%20a%20modern%20office%2C%20soft%20natural%20lighting%2C%20professional%20yet%20romantic%20atmosphere%2C%20webtoon%20style%2C%20clean%20elegant%20design&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '新入职的菜鸟员工和公司里公认的完美上司之间发生的故事。在一次次的合作中，两人发现了彼此不为人知的一面。办公室里的暗恋，茶水间的偶遇，加班后的晚餐——一部让人心动的职场爱情故事。',
    status: '连载中',
    rating: 4.6,
    views: 1980000,
    updatedAt: '2026-08-04',
    tags: ['职场', '办公室恋爱', '暗恋', '年上'],
    chapters: [
      { id: 'ch-11-30', comicId: 'comic-11', title: '第30话 加班之夜', number: 30, updatedAt: '2026-08-04', views: 92000 },
      { id: 'ch-11-29', comicId: 'comic-11', title: '第29话 酒后真言', number: 29, updatedAt: '2026-07-28', views: 98000 },
    ],
  },
  {
    id: 'comic-12',
    title: '异世界食堂',
    author: '沈佑镇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20illustration%20of%20a%20magical%20restaurant%20with%20floating%20food%20and%20fantasy%20creatures%20as%20customers%2C%20warm%20golden%20interior%20lighting%2C%20whimsical%20atmosphere%2C%20webtoon%20style%2C%20detailed%20food%20illustrations%2C%20cozy%20vibe&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '普通厨师韩东秀意外发现自己可以通过一扇神秘的门进入异世界。他在那里开了一家小小的食堂，用人类世界的美食征服了精灵、矮人、龙族等奇幻生物。美食与奇幻的完美融合，让人垂涎欲滴又心驰神往。',
    status: '连载中',
    rating: 4.8,
    views: 1670000,
    updatedAt: '2026-08-03',
    tags: ['异世界', '美食', '治愈', '冒险'],
    chapters: [
      { id: 'ch-12-25', comicId: 'comic-12', title: '第25话 龙族的委托', number: 25, updatedAt: '2026-08-03', views: 82000 },
      { id: 'ch-12-24', comicId: 'comic-12', title: '第24话 精灵的宴会', number: 24, updatedAt: '2026-07-27', views: 87000 },
    ],
  },
];

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getComicsByCategory = (slug: string): Comic[] => {
  return comics.filter((c) => c.categorySlug === slug);
};

export const getLatestComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
};

export const getHotComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getCategoryName = (slug: string): string => {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
};